import React, { Component } from "react"
import { FilterStore, locale, compose } from "@albelli/photoselector"
import { ContainerListView, VerticalSquareLayout } from "@albelli/list-view-react"

import withRequest from "../../Http/withRequest"
import Filters from "../../Components/Filters"
import SortingSelector from "../../Components/SortingSelector"
import SelectYear from "../../Components/SelectYear"
import trackScrolling from "../../Scrolling"
import { Calendar } from "../../Overlays/Calendar"
import { CategoryItemContainer, PhotoOrganiserItem } from "../../Components/CategoryItemContainer"

interface EventsProps {
  navigateTo: (id: string) => void
  items: PhotoOrganiserItem[]
  totalItemsCount: number
  getItems: () => void
  sortingDirection: string
  yearsWithPhotos: any[]
  setSelectedYear: (number: number) => void
  handleSortingChange: (comp: any, e: any) => void
}

class Events extends Component<EventsProps, {}> {
  private scrollHandler: (ev: any) => void

  constructor(props: EventsProps) {
    super(props)

    this.scrollHandler = trackScrolling(this)
  }

  render() {
    const { items } = this.props
    const layout = new VerticalSquareLayout(300, 5)
    const { getItems, sortingDirection, yearsWithPhotos, setSelectedYear, handleSortingChange, totalItemsCount } = this.props

    return (
      <>
        {items.length > 0 && (
          <Filters store={FilterStore} disableDefault={true}>
            <SelectYear yearsWithPhotos={yearsWithPhotos} setSelectedYear={setSelectedYear} getItems={getItems} />
            <SortingSelector sortingDirection={sortingDirection} handleSortingChange={handleSortingChange} />
          </Filters>
        )}
        <div className="photoselector-photoorganiser-collections-events-counter" data-tam="events-count">
          {totalItemsCount} {locale.get().photoorganiser.navigation.events.toLowerCase()}
        </div>
        <ContainerListView
          className="photo-organiser-image-container-hover photo-organiser-image-container"
          layout={layout}
          items={items}
          onScroll={this.scrollHandler}
        >
          {(item) => (
            <CategoryItemContainer item={item as PhotoOrganiserItem} navigateTo={this.props.navigateTo}>
              <Calendar item={item as PhotoOrganiserItem}></Calendar>
            </CategoryItemContainer>
          )}
        </ContainerListView>
      </>
    )
  }
}

export default compose(withRequest)(Events)
